window.addEventListener('DOMContentLoaded', () => {
  $('.usp-slider__slider.am-slider').slick({
    slidesToShow: 3,
    autoplay: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
            slidesToShow: 1
        }
      }
    ]
  });
});
